import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewEditDirective } from './view-edit.directive';



@NgModule({
  declarations: [ViewEditDirective],
  imports: [
    CommonModule
  ],
  exports:[ViewEditDirective]
})
export class ViewEditModule { }
